import { useContext } from "react";
import { filterStyledSystemMarginProps } from "../../../style/utils";
import { FormSpacingContext } from "../../../__internal__/form-spacing-provider";
import addFormSpacing from "./add-form-spacing";
export default (props => {
  const {
    marginBottom
  } = useContext(FormSpacingContext);
  const marginProps = addFormSpacing(filterStyledSystemMarginProps(props), marginBottom);
  return marginProps;
});